import { render, staticRenderFns } from "./MensajeActividad.vue?vue&type=template&id=8b49bd42&scoped=true"
import script from "./MensajeActividad.vue?vue&type=script&lang=js"
export * from "./MensajeActividad.vue?vue&type=script&lang=js"
import style0 from "./MensajeActividad.vue?vue&type=style&index=0&id=8b49bd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b49bd42",
  null
  
)

export default component.exports